import { CustomType } from "./enums";

const values = {
  event_agent: {
    data: [
      {
        id: "agent_handled",
        text: "biz_rule.val.agent_handled",
        is_translate: true,
      },
      {
        id: "agent_joined",
        text: "biz_rule.val.agent_joined",
        is_translate: true,
      },
      { id: "agent_left", text: "biz_rule.val.agent_left", is_translate: true },
      {
        id: "agent_served",
        text: "biz_rule.val.agent_served",
        is_translate: true,
      },
      {
        id: "agent_convert_ticket",
        text: "biz_rule.val.agent_convert_ticket",
        is_translate: true,
      },
    ],
    type: CustomType.dropdown,
  },
  event_requester: {
    data: [
      {
        id: "requester_started",
        text: "biz_rule.val.requester_started",
        is_translate: true,
      },
    ],
    type: CustomType.dropdown,
  },
  agent_online: {
    type: CustomType.numeric,
  },
  state: {
    data: [
      { id: "offline", text: "biz_rule.val.offline", is_translate: true },
      { id: "spam", text: "biz_rule.val.spam", is_translate: true },
      { id: 3, text: "biz_rule.val.closed", is_translate: true },
    ],
    type: CustomType.dropdown,
  },
};

export const triggerOperators = {
  agent_online: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "less_than", text: "biz_rule.opt.less_than", is_translate: true },
    {
      id: "greater_than",
      text: "biz_rule.opt.greater_than",
      is_translate: true,
    },
  ],
  status: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
    { id: "less_than", text: "biz_rule.opt.less_than", is_translate: true },
    {
      id: "greater_than",
      text: "biz_rule.opt.greater_than",
      is_translate: true,
    },
    {
      id: "changed",
      text: "biz_rule.opt.changed",
      is_show_value: false,
      is_translate: true,
    },
    {
      id: "changed_from",
      text: "biz_rule.opt.changed_from",
      is_translate: true,
    },
    {
      id: "not_changed",
      text: "biz_rule.opt.not_changed",
      is_show_value: false,
      is_translate: true,
    },
    {
      id: "not_changed_from",
      text: "biz_rule.opt.not_changed_from",
      is_translate: true,
    },
  ],
  group: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
    {
      id: "changed",
      text: "biz_rule.opt.changed",
      is_show_value: false,
      is_translate: true,
    },
    {
      id: "changed_from",
      text: "biz_rule.opt.changed_from",
      is_translate: true,
    },
    {
      id: "not_changed",
      text: "biz_rule.opt.not_changed",
      is_show_value: false,
      is_translate: true,
    },
    {
      id: "not_changed_from",
      text: "biz_rule.opt.not_changed_from",
      is_translate: true,
    },
  ],
  org: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
  ],
  tag: [
    { id: "includes", text: "biz_rule.opt.includes", is_translate: true },
    {
      id: "not_includes",
      text: "biz_rule.opt.not_includes",
      is_translate: true,
    },
  ],
  channel: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
  ],
  comment_text: [
    { id: "includes", text: "biz_rule.opt.includes", is_translate: true },
    {
      id: "not_includes",
      text: "biz_rule.opt.not_includes",
      is_translate: true,
    },
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
  ],
  reopen: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "less_than", text: "biz_rule.opt.less_than", is_translate: true },
    {
      id: "greater_than",
      text: "biz_rule.opt.greater_than",
      is_translate: true,
    },
  ],
  current_user: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
  ],
  custom_setting_text: [
    { id: "includes", text: "biz_rule.opt.includes", is_translate: true },
    {
      id: "not_includes",
      text: "biz_rule.opt.not_includes",
      is_translate: true,
    },
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
  ],
  custom_setting_chips: [
    { id: "includes", text: "biz_rule.opt.includes", is_translate: true },
    {
      id: "not_includes",
      text: "biz_rule.opt.not_includes",
      is_translate: true,
    },
  ],
  custom_setting_number: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
    { id: "less_than", text: "biz_rule.opt.less_than", is_translate: true },
    {
      id: "greater_than",
      text: "biz_rule.opt.greater_than",
      is_translate: true,
    },
  ],
  custom_setting_date: [
    { id: "is", text: "biz_rule.opt.is", is_translate: true },
    { id: "is_not", text: "biz_rule.opt.is_not", is_translate: true },
    {
      key: "present",
      text: "biz_rule.opt.present",
      is_show_value: false,
      is_translate: true,
    },
    {
      key: "not_present",
      text: "biz_rule.opt.not_present",
      is_show_value: false,
      is_translate: true,
    },
    { key: "before", text: "biz_rule.opt.before", is_translate: true },
    { key: "before_on", text: "biz_rule.opt.before_on", is_translate: true },
    { key: "after", text: "biz_rule.opt.after", is_translate: true },
    { key: "after_on", text: "biz_rule.opt.after_on", is_translate: true },
    {
      id: "is_within_previous",
      text: "biz_rule.opt.is_within_the_previous",
      is_translate: true,
    },
    {
      id: "is_within_the_next",
      text: "biz_rule.opt.is_within_the_next",
      is_translate: true,
    },
  ],
};

export const triggerConditions = [
  {
    id: "event_agent",
    text: "biz_rule.cond.event_agent",
    values: values.event_agent,
    is_translate: true,
    cond_type: 1,
  },
  {
    id: "event_requester",
    text: "biz_rule.cond.event_requester",
    values: values.event_requester,
    is_translate: true,
    cond_type: 1,
  },
  {
    id: "agent_online",
    text: "biz_rule.cond.agent_online",
    values: values.agent_online,
    operator: triggerOperators.agent_online,
    is_translate: true,
    cond_type: 3,
  },
];

export const triggerActions = [
  {
    id: "notify_message",
    text: "biz_rule.action.notify_message",
    desc: "biz_rule.action.notify_message_desc",
    fields: {
      body: {
        text: "biz_rule.action.message_content",
        type: CustomType.textarea,
        desc: "biz_rule.action.message_content",
      },
    },
    is_translate: true,
    act_type: 2,
  },
  {
    id: "info_message",
    text: "biz_rule.action.info_message",
    desc: "biz_rule.action.info_message_desc",
    fields: {
      subject: {
        text: "biz_rule.action.message_header",
        type: CustomType.text,
        desc: "biz_rule.action.message_header",
      },
      body: {
        text: "biz_rule.action.message_content",
        type: CustomType.textarea,
        desc: "biz_rule.action.message_content",
      },
    },
    is_translate: true,
    act_type: 2,
  },
];
